<template>
  <li class="row py20">
    <div class="blend bg-cl-secondary" @click="closeWishlist">
      <a :href="productLink">
        <product-image-cloudfront
          class="product__image-wrapper"
          :thumbnail-path="product.thumbnail_path"
          :thumbnail-size="'40'"
        />
      </a>
    </div>
    <div class="col-xs between-xs flex pl40 py15">
      <div @click="closeWishlist">
        <a :href="productLink"
          class="sans-serif h5 name cl-mine-shaft"
        >
          {{ product.name | htmlDecode }}
        </a>
        <div class="h6 cl-bg-tertiary pt5 sku">
          {{ product.sku }}
        </div>
      </div>
    </div>
    <div class="inline-flex py10 align-right">
      <div class="inline-flex align-items-center">
        
        <div v-if="product.price_incl_tax">
          <span class="price-special">{{ product.price_incl_tax | price(storeView) }}</span>&nbsp;
        </div>

        <div class="px10 cart-icon" v-if="showAddToCart">
          <add-to-cart
            :product="product"
            class="wishlist-add-to-cart-icon"
            :class="[
              { 'bg-cl-mine-cart': product.catalog === config.rootcategories.drukowanie },
              { 'bg-cl-office-cart': product.catalog === config.rootcategories.biuro }
            ]"
          />
        </div>

        <div>
          <div>
            <span @click="removeProductFromWhishList(product)"><remove-button class="cl-accent" /></span>
          </div>
        </div>
      </div>
    </div>
  </li>
</template>

<script>
import config from 'config';
import Product from '@vue-storefront/core/compatibility/components/blocks/Wishlist/Product';
import { currentStoreView } from '@vue-storefront/core/lib/multistore';
import { formatProductLink } from '@vue-storefront/core/modules/url/helpers';
import ProductImage from 'theme/components/core/ProductImage';
import ProductImageCloudfront from 'theme/components/core/ProductImageCloudfront';
import RemoveButton from './RemoveButton';
import i18n from '@vue-storefront/i18n';
import { htmlDecode } from '@vue-storefront/core/lib/store/filters';
import AddToCart from 'theme/components/core/AddToCartIcon';

export default {
  data () {
    return {
      config
    }
  },
  components: {
    RemoveButton,
    ProductImage,
    AddToCart,
    ProductImageCloudfront
  },
  mixins: [Product],
  props: {
    showAddToCart: {
      type: Boolean,
      default: true
    },
    categoryProps: {
      type: String,
      default: config.rootcategories.drukowanie
    }
  },
  computed: {
    productLink () {
      if(this.product.catalog === config.rootcategories.biuro) {
         return config.site.office_path + '/' + this.product.url_path
      } else {
         return config.baseUrl + this.product.url_path 
        // return formatProductLink(this.product, currentStoreView().storeCode)
      }      
    },
    image () {
      return {
        loading: this.thumbnail,
        src: this.thumbnail
      }
    },
    storeView () {
      return currentStoreView()
    }
  },
  methods: {
    removeProductFromWhishList (product) {
      this.$store.dispatch('notification/spawnNotification', {
        type: 'success',
        message: i18n.t('Product {productName} has been removed from wishlist!', { productName: htmlDecode(product.name) }),
        action1: { label: i18n.t('OK') }
      }, { root: true })
      this.removeFromWishlist(product)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/animations/transitions';
@import "~theme/css/variables/colors";

.blend {
  flex: 0 0 60px;
  opacity: .8;
  will-change: opacity;
  transition: .3s opacity $motion-main;
  &:hover{
     opacity: 1;
   }
}
.pr40 {
  padding-right: 40px;
}
.col-xs {
  flex-direction: column;
}
.align-items-center {
  align-items: center;
  justify-content: flex-end;
}
input {
  width: 30px;
}
.cart-icon {
  width: 70px;
  box-sizing: border-box;
}
.price-original {
  text-decoration: line-through;
  color: #828282;
  font-size: .95rem;
}
.wishlist-add-to-cart {
  margin: 0 0;
  font-size: 14px;
  text-align: center;
  box-sizing: border-box;
  min-width: 40px;
  width: 40px;
  height: 40px;
  border-radius: 22px;
  padding: 8px;
}
.price-original {
  text-decoration: line-through;
  color: #828282;
  font-size: .95rem;
}
.price-original {
  text-decoration: line-through;
  color: #828282;
  font-size: .95rem;
}
.bg-cl-office-cart{
  background-color: $office-primary;
}
</style>
